const CancelablePromise = (promise) => {
  let hasCanceled_ = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then((val) =>
      hasCanceled_ ? reject({isCanceled: true}) : resolve(val)
    );
    promise.catch((error) =>
      hasCanceled_ ? reject({isCanceled: true}) : reject(error)
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    },
  };
};

export default CancelablePromise;

/**
 * How to Use
 *
 *
   this.reloadingStatsPromise = CancelablePromise(new Promise(async (resolve) => {
     this.$store.commit("statsKpi/resetKpiRowInfoAmount")
     await this.$refs.todayColumn.getColumnAmounts();
     for(let i=0; i <  this.$refs.columns.length; i++) {
      await this.$refs.columns[i].getColumnAmounts();
     }

     resolve();
   }))

    cancelablePromise.cancel(); // Cancel the promise
 */
